import { c as _c } from "react/compiler-runtime";
import { getOrgEntityStatusesQueryKey, patchOrgEntityStatusesBySlugMutation } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import { IcoPencil16, IcoPlusBig16 } from '@onefootprint/icons';
import type { EntityOrgStatus } from '@onefootprint/request-types/dashboard';
import { Card, IconButton } from '@onefootprint/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomStatusEditDialog from '../custom-status-edit-dialog';
import CustomStatusEntryItem from '../custom-status-entry';
import type { CustomStatusEntry, CustomStatusEntryFormData } from '../custom-status-entry/custom-status-entry';
type CustomStatusProps = {
  customStatus: EntityOrgStatus;
  canEdit: boolean;
  isBuiltIn?: boolean;
  shouldShowSlug: boolean;
};
const CustomStatusCard = t0 => {
  const $ = _c(52);
  const {
    customStatus,
    canEdit,
    isBuiltIn: t1,
    shouldShowSlug
  } = t0;
  const isBuiltIn = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "pages.statuses.customStatusCard"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("settings", t2);
  const [showAddCustomStatusEntryDialog, setShowAddCustomStatusEntryDialog] = useState(false);
  let t3;
  if ($[1] !== customStatus.entries) {
    t3 = () => customStatus.entries.map(_temp);
    $[1] = customStatus.entries;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [allEntries, setAllEntries] = useState(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = patchOrgEntityStatusesBySlugMutation();
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const editCustomStatusMutation = useMutation(t4);
  const showRequestErrorToast = useRequestErrorToast();
  const queryClient = useQueryClient();
  let t5;
  let t6;
  if ($[4] !== customStatus.entries) {
    t5 = () => {
      setAllEntries(prev => {
        const prevEditingMap = new Map(prev.map(_temp2));
        const tempEntries = prev.filter(_temp3);
        return [...customStatus.entries.map(entry_0 => ({
          ...entry_0,
          isEditing: prevEditingMap.get(entry_0.id) ?? false
        })), ...tempEntries];
      });
    };
    t6 = [customStatus.entries];
    $[4] = customStatus.entries;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setAllEntries(_temp5);
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const addCustomStatusEntry = t7;
  let t8;
  if ($[8] !== customStatus.displayName || $[9] !== customStatus.entityType || $[10] !== customStatus.slug || $[11] !== editCustomStatusMutation || $[12] !== queryClient || $[13] !== showRequestErrorToast) {
    t8 = async (entryData, entryId) => {
      ;
      try {
        await editCustomStatusMutation.mutateAsync({
          path: {
            slug: customStatus.slug
          },
          body: {
            displayName: customStatus.displayName,
            entityType: customStatus.entityType,
            entries: [entryData]
          }
        });
        if (entryId.startsWith("custom-entry-temp-id-")) {
          setAllEntries(prev_1 => prev_1.filter(e_2 => e_2.id !== entryId));
        } else {
          setAllEntries(prev_2 => prev_2.map(e_3 => e_3.id === entryId ? {
            ...e_3,
            isEditing: false
          } : e_3));
        }
        queryClient.invalidateQueries({
          queryKey: getOrgEntityStatusesQueryKey()
        });
      } catch (t9) {
        const error = t9;
        showRequestErrorToast(error);
      }
    };
    $[8] = customStatus.displayName;
    $[9] = customStatus.entityType;
    $[10] = customStatus.slug;
    $[11] = editCustomStatusMutation;
    $[12] = queryClient;
    $[13] = showRequestErrorToast;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const handleCustomStatusEntrySave = t8;
  let t9;
  if ($[15] !== canEdit || $[16] !== isBuiltIn || $[17] !== t) {
    t9 = () => {
      if (canEdit) {
        return <div className="flex gap-2"><IconButton icon={IcoPlusBig16} aria-label={t(_temp6)} onClick={addCustomStatusEntry} size="tiny" /><IconButton icon={IcoPencil16} size="tiny" aria-label={t(_temp7)} onClick={() => {
            setShowAddCustomStatusEntryDialog(true);
          }} /></div>;
      }
      if (isBuiltIn) {
        return <p className="text-body-2 text-tertiary">{t(_temp8)}</p>;
      }
      return null;
    };
    $[15] = canEdit;
    $[16] = isBuiltIn;
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const renderHeaderActions = t9;
  const t10 = customStatus.displayName;
  let t11;
  if ($[19] !== renderHeaderActions) {
    t11 = renderHeaderActions();
    $[19] = renderHeaderActions;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== customStatus.displayName || $[22] !== t11) {
    t12 = <Card.Header title={t10} rightContent={t11} />;
    $[21] = customStatus.displayName;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== allEntries || $[25] !== canEdit || $[26] !== handleCustomStatusEntrySave || $[27] !== shouldShowSlug) {
    let t14;
    if ($[29] !== allEntries.length || $[30] !== canEdit || $[31] !== handleCustomStatusEntrySave || $[32] !== shouldShowSlug) {
      t14 = (entry_1, index) => <CustomStatusEntryItem key={entry_1.id} entry={entry_1} showDivider={index < allEntries.length - 1} shouldShowSlug={shouldShowSlug} canEdit={canEdit} onSave={entryData_0 => handleCustomStatusEntrySave(entryData_0, entry_1.id)} onEdit={() => {
        setAllEntries(prev_3 => prev_3.map(e_4 => e_4.id === entry_1.id ? {
          ...e_4,
          isEditing: true
        } : e_4));
      }} onCancel={() => {
        if (entry_1.id.startsWith("custom-entry-temp-id-")) {
          setAllEntries(prev_4 => prev_4.filter(e_5 => e_5.id !== entry_1.id));
        } else {
          setAllEntries(prev_5 => prev_5.map(e_6 => e_6.id === entry_1.id ? {
            ...e_6,
            isEditing: false
          } : e_6));
        }
      }} />;
      $[29] = allEntries.length;
      $[30] = canEdit;
      $[31] = handleCustomStatusEntrySave;
      $[32] = shouldShowSlug;
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    t13 = allEntries.map(t14);
    $[24] = allEntries;
    $[25] = canEdit;
    $[26] = handleCustomStatusEntrySave;
    $[27] = shouldShowSlug;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[34] !== t13) {
    t14 = <div className="flex flex-col p-2 gap-2">{t13}</div>;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setShowAddCustomStatusEntryDialog(false);
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== customStatus.displayName || $[38] !== customStatus.entityType || $[39] !== customStatus.entries || $[40] !== customStatus.slug) {
    t16 = {
      displayName: customStatus.displayName,
      slug: customStatus.slug,
      entityKind: customStatus.entityType,
      entries: customStatus.entries
    };
    $[37] = customStatus.displayName;
    $[38] = customStatus.entityType;
    $[39] = customStatus.entries;
    $[40] = customStatus.slug;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== customStatus.entityType || $[43] !== showAddCustomStatusEntryDialog || $[44] !== t16) {
    t17 = <CustomStatusEditDialog entityKind={customStatus.entityType} open={showAddCustomStatusEntryDialog} onClose={t15} defaultValues={t16} />;
    $[42] = customStatus.entityType;
    $[43] = showAddCustomStatusEntryDialog;
    $[44] = t16;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t14 || $[47] !== t17) {
    t18 = <Card.Body>{t14}{t17}</Card.Body>;
    $[46] = t14;
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== t12 || $[50] !== t18) {
    t19 = <Card.Root>{t12}{t18}</Card.Root>;
    $[49] = t12;
    $[50] = t18;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  return t19;
};
export default CustomStatusCard;
function _temp(entry) {
  return {
    ...entry,
    isEditing: false
  };
}
function _temp2(e) {
  return [e.id, e.isEditing];
}
function _temp3(e_0) {
  return e_0.id.startsWith("custom-entry-temp-id-");
}
function _temp4(e_1) {
  return e_1.id.startsWith("custom-entry-temp-id-");
}
function _temp5(prev_0) {
  return [...prev_0, {
    id: `custom-entry-temp-id-${prev_0.filter(_temp4).length + 1}`,
    displayName: "",
    slug: "",
    hexCode: "#000000",
    isEditing: true
  }];
}
function _temp6($) {
  return $.add;
}
function _temp7($_0) {
  return $_0.edit;
}
function _temp8($_1) {
  return $_1.builtIn;
}